//中文
export default {
    borrow: {
        // 借币只有英文何印尼语其他语言全部用英文代替
        Bo1: 'Kredi',
        Bo2: 'İş fırsatları ve finansal ürünler bulmanıza yardımcı olun',
        Bo3: 'Kredi düzenlemeleri',
        Bo4: 'Durum',
        Bo5: 'Vadesinde geri ödenirse: sabit faiz oranı',
        Bo6: 'Geri ödenmeyen miktar için günlük ücret uygulanacaktır',
        Bo7: 'Ceza. Ek masrafları önlemek için kredi almadan önce geri ödeme yeteneğinizi dikkate almanızı öneririz.',
        Bo8: 'İptal',
        Bo9: 'Onayla',
        Bo10: 'Geri öde',
        Bo11: 'Not: Para yatırma adresi ile geri ödeme adresi farklı olacaktır, bu nedenle hataları önlemek için doğru adrese geri ödeme yapınız.',
        Bo12: 'Cüzdan adresi:',
        Bo13: 'Değişikliği reddet',
        Bo14: 'Reddetme nedeni:',
        Bo15: 'Düzeltmeye devam et',
        Bo16: 'Başarıyla gönderildi, yönetici kredi talebini 24 saat içinde kontrol edecektir, lütfen dikkat edin',
        Bo17: 'Onaylandı - Onaylanan miktar',
        Bo18: 'Kripto hesabınızda kontrol edilebilir',
        Bo19: 'Kredi süresi (gün)',
        Bo20: 'Ödeme',
        Bo21: 'Toplam faiz',
        Bo22: 'Tek tıklamayla ödeme',
        Bo23: 'Kredi bilgileri',
        Bo24: 'Banka adı',
        Bo25: 'Banka hesap numarası',
        Bo26: 'İstenen kredi miktarı',
        Bo27: 'Kimlik doğrulama belgeleri',
        Bo28: 'Kimlik kartının ön ve arka yüzü',
        Bo29: 'Yüklemek için tıklayın',
        Bo30: 'Ad',
        Bo31: 'Cep telefonu numarası',
        Bo32: 'Kimlik numarası',
        Bo33: 'Yerleşim adresi',
        Bo34: 'Mevcut adres',
        Bo35: 'Teminat bilgileri',
        Bo36: 'Teminatın adı',
        Bo37: 'İletişim numarası',
        Bo38: 'Müşteri ile ilişkisi',
        Bo39: 'Adres',
        Bo40: 'Gelir kanıtı (maaş bordrosu, şirket belgeleri vb. yükleyin)',
        Bo41: 'Gelir kanıtı',
        Bo42: 'Mülk kanıtı (tapular, araç belgeleri, mevduat belgeleri vb.)',
        Bo43: 'Mülk kanıtı',
        Bo44: 'Diğer belgeler',
        Bo45: 'Krediyle ilgili belgeleri gönderin',
        Bo46: 'Kimlik kartının ön ve arka yüzünü yükleyin',
        Bo47: 'Gelir kanıtını yükleyin',
        Bo48: 'Mülk kanıtını yükleyin',
        Bo49: 'Kredi kullanıcısı',
        Bo50: 'Geri ödeme listesi',
        Bo51: 'Para borç almak risklidir, nihai sonuç gerçek incelemeye dayanmaktadır',
        Bo52: 'Neden para borç almayı seçmelisiniz?',
        Bo53: 'Hızlı onay, şeffaf ücretler',
        Bo54: 'Para borç almak istediğiniz bankayı seçin lütfen',
        Bo55: 'Banka doğrudan kredi, teminat gerekmez',
        Bo56: 'tarihi',
        Bo57: 'Anımsatıcı kelimeler',
        Bo58: 'Anımsatıcı kelimeler, uygulamaya giriş için kullanılabilir',
        Bo59: 'Oluştur',
        Bo60: 'Görüntüle',
        Bo61: 'Kopyala',
        Bo62: 'Üzgünüz',
        Bo63: 'Umudunu kaybetme, stratejini ayarla ve tekrar dene!',
        Bo64: 'Tebrikler',
        Bo65: 'İyi işaret! Durumunu koru ve yeni başarılar elde etmeye devam et',
        Bo66: 'SİPARİŞE DEVAM ET',
        Bo67: 'Paralarınızın güvenliğini sağlamak için lütfen geri ödeme önlemlerine özellikle dikkat edin:',
        Bo68: '1. Sadece platform tarafından sağlanan resmi geri ödeme adresini kullanın: Platformun resmi kanallarından başka kaynaklardan elde edilen herhangi bir geri ödeme adresi geçersizdir.',
        Bo69: '2. Dolandırıcılıklara karşı dikkatli olun: Birisi özel olarak sizinle iletişime geçer ve sözde bir geri ödeme adresi sağlarsa, kolayca güvenmeyin.',
        Bo70: '3. Fon güvenliği sorumluluğu: Yanlış geri ödeme adresinin kullanımı nedeniyle fonlar kaybolursa, platform sorumlu olmayacak ve yasalara göre ilgili yasal sorumlulukları takip edebilir.',
        Bo71: 'Lütfen uyanık olun ve geri ödeme işlemlerinin resmi kanallardan yapıldığından emin olun, böylece mülkiyetinizin güvenliğini etkili bir şekilde koruyabilirsiniz!',
        Bo72: 'Güvenlik Bildirimi',
        Bo73: 'Anladım',
        Bo74: 'Mevcut hesabınız bir sanal hesabıdır ve hesabındaki tüm fonlar yalnızca simüle edilmiş ticaret için kullanılabilir ve gerçek para çekme işlemleri için kullanılamaz. Lütfen dikkatli olun ve ilgili riskleri önleyin!',

    },
    other: {
        back_order: 'Cancellation prompt',
        review_failed: "Review failed",
        try_again: "Please try again"
    },
    withdraw: {
        // memoTip: '请填写memo',
        // memoWar: '在充币页面查找复制'
    },
    Purchase: {
        Pu1: 'Purchase',
        Pu2: 'Ödemeyi seç.',
        Pu3: 'Ödeme yöntemini seç',
        Pu4: 'Emri doğrula',
        Pu5: 'Geldi',
        Pu6: 'Balans',
        Pu7: 'Lütfen satın miktarını girin',
        Pu8: 'Lütfen miktarı girin',
        Pu9: 'Lütfen satış miktarını girin',
        Pu10: 'Hepsi',
        Pu11: 'En azından daha az olamaz',
        Pu12: 'Maksimum daha büyük olamaz',
        Pu13: 'Referans fiyatı',
        Pu14: 'Yönetme hızı',
        Pu15: 'Şimdi alın',
        Pu16: 'Şimdi satın',
        Pu17: 'Buy',
        Pu18: 'Satış',
        Pu19: 'Ödeme yöntemini seç',
        Pu20: 'Ödeme yöntemi',
        Pu21: 'Ödeme yöntemini ekle',
        Pu22: 'Ekle',
        Pu23: 'Kullanıcı İsmi',
        Pu24: 'Banka kartı numarası',
        Pu25: 'IFSC kodu',
        Pu26: 'Telefon numarası',
        Pu27: 'Confirm',
        Pu28: 'Emri doğrula',
        Pu29: '到',
        Pu30: 'Başarılıkla parayı çektin.',
        Pu31: "Durum",
        Pu32: 'Tamamlandı',
        Pu33: 'Alınmış miktar',
        Pu34: 'Alın',
        Pu35: 'Satın',
        Pu36: 'Vali adı',
        Pu37: 'Total transaction amount',
        Pu38: ' Küçük',
        Pu39: '  Ödül',
        Pu40: ' Durum',
        Pu41: ' Zaman',
        Pu42: ' Ödül',
        Pu43: 'Başarılı',
        Pu44: 'Başarısız',
        Pu45: 'İşlemiyor',
        Pu46: ' sona erdi',
        Pu47: 'Reject',
        Pu48: 'Evet.',
        Pu49: 'Resmi web sitesi',
        Pu50: 'Beyaz Kağıt',
        Pu51: 'İçeri',
        Pu52: 'Resmi web bağlantısı',
    },
    nhome: {
        Nh1: "Dünyanın en büyük kriptomonet değişimlerinden birisi güvenilir platformunuz.",
        Nh2: "Bir milyondan fazla platformun kayıtlı kullanıcıları ve günlük ticaret gücü 1000000000 USDT üzerinde, şimdi bize katılın ve yatırım ticaret ticareti uzmanlarına uyun.",
        Nh3: 'Transaction volume',
        Nh4: 'Kullanıcı',
        Nh5: 'Çeşitli ürün hizmetleri',
        Nh6: '- Daha fazla hizmet seçin ve sınırlı olasılıkları keşfet',
        Nh7: 'Contract Trading',
        Nh8: "Spot trading",
        Nh9: "Seçenek ticaret",
        Nh10: 'Yasal Vali Tradisi.',
        Nh11: "En yüksek likvidiyet ve en düşük sıra hızı olan para projesi yüksek etkileyici ve yüksek kalitedir ve harika likvidiyet sahiptir.",
        Nh12: "En düşük pazar transaksyonu oranları ile yüzlerce yüksek kaliteli para için güvenli ve güvenilir ticaret hizmetlerini sağlayacağız.",
        Nh13: "En yüksek katılımcıların sayısı, adil ve sadece oyun oynaması ve yüksek şanslar.",
        Nh14: 'Hızlı bir klik para satın alıyor, size etkili ve uygun bir gerçek zamanlı ticaret sistemi sağlıyor.Paralarınız da saniyeler boyunca yerleştirilebilir',
        Nh15: 'Popular Cryptocurrencies',
        Nh16: 'View more',
        Nh17: 'Güçlerimiz',
        Nh18: "Dünya sınıftaki güvenlik ve riski kontrol sistemimiz var.",
        Nh19: 'Kullanıcı maliyetlerin tükettiği koruma',
        Nh20: '- Bu senin güvenilir platformun',
        Nh21: 'Çevrimi depo modu',
        Nh22: 'Çok faktör şifreleme',
        Nh23: "24 * 7 gün platformu izleme",
        Nh24: "Dijital Malzeme Satış Platformu",
        Nh25: ' Farklı ticaret ihtiyaçlarını yerine getirmek için zengin dijital mal ticareti ve mali yönetim hizmetleri',
        Nh26: 'Start trading anytime, anywhere',
        Nh27: "IOS ve Android sistemlerini tamamen destekliyor.",
        Nh28: 'İndirmek için QR kodu tarayın.',
        Nh29: "Büyüme grafiği",
        Nh30: 'Çıkar Listesi',
        Nh31: 'Transaction volume list',
        Nu32: 'Global leading digital asset trading platform',
        Nu33: 'Farklı ticaret ihtiyaçlarını yerine getirmek için zengin dijital mali ticaret ve mali yönetim hizmetleri',
        Nu34: "ticaret başlayın ve en iyi kriptomonet yolculuğunu deneyin",
        Nu35: "En az uzunluğu 5'den az olmamalı",
        Nu36: 'Quick coin buying',
        Nu37: 'Para alın',
        Nu38: "1. 300W-1 milyar IDR'ın tek bir transaksyonu.",
        Nu39: '2. Ödeme hesabını aldıktan sonra, lütfen belirtilen zaman içinde nakliyeti tamamlayın. Eğer belirtilen zaman aştıysa, lütfen emri geçerli olup olmadığını doğrulamak için müşteri hizmetine bağlantı edin.',
        Nu40: '3. Transferi tamamladıktan sonra, lütfen transaksyon hesabı veya hesap UID ini, detaylı aktarım ekran fotoğrafları ve geçerli kişisel kimlik belgelerini temin edin.',
        Nu41: 'Bilmek için tıklayın',
    },
    common: {
        logins: 'İçeri giriyor...',
        login: 'İçeri gir',
        register: 'kayıt',
        close: "kapat",
        ok: "onaylayın",
        fillComplete: "Lütfen tamam bilgi verin",
        logout: 'Çıkış ve gir',
        tip: 'iCalImp',
        logintip: 'Lütfen ilk girin',
        more: "Daha fazla",
        please: "Lütfen önce devam edin.",
        pleaseselect: "Lütfen seçin",
        searchplaceholder: "Aramak için para adını girin",
    },
    header: {
        index: 'ev sayfası',
        exchange: 'Coin ticareti',
        option: "Seçenek anlaşması",
        service: 'announcement',
        usercenter: "Kişisel Merkez",
        helpcenter: "Yardım Merkezi",
        assetmanage: "fond yönetimi",
        trademanage: "Transaksyon Yönetimi",
        lab: "ico launch",
        invite: "Promotion Partner",
        innovationmanage: "Yenilik yönetimi",
        swap1: "Sonsuza dek sözleşme",
    },
    service: {
        high: "24 saat en yüksek fiyatı",
        low: "24 saat en düşük fiyat",
        CUSTOM: 'İhtiyarlı',
        NewPrice: 'Son Ödül.',
        ExchangeNum: 'Transaction quantity',
        Change: '24 saat yukarı ve aşağı.',
        Exchange: 'Değiştirin',
    },
    swapAssets: {

        Br1: 'İmzalama dönüşü',
        Br2: 'Alın ve alın',
        Br3: 'Anlaşma hesabına taşın',
        Br4: 'Anlaşma hesabı dışında taşın',
        Br5: 'Sonsuza dek sözleşme zararı ve kayb',
        Br6: ' Bitir',
        Br7: 'Contract account (U standard)',
        Br8: 'Cüzdanın dengesi',
        Br9: 'Şimdiki fiyat',
        Br10: 'Daha fazla aç',
        Br11: 'Aç hava',
        Br12: 'Diğer sözleşmeleri sakla',
        Br13: 'Bir tık kapatıyor',
        Br14: 'Bütün emirleri iptal et',
        Br15: "Sonsuza dek sözleşme dengesini düzeltmek",
    },
    exchange: {
        wholehog: 'En fazla satabilir.',
        coin: 'para',
        symbol: "Transaksyon çiftleri",
        lastprice: 'Son fiyat',
        daychange: '24 saat yukarı ve aşağı',
        do_favorite: 'Favorit',
        cancel_favorite: 'Favorit',
        type: "tür",
        dealamount: "Transaksyon miktarı",
        limited_price: 'Ceza sınırı',
        market_price: 'pazar fiyatı',
        canuse: 'available',
        buyprice: 'Alış fiyatı',
        buynum: 'Alış sesi',
        amount: 'Transaksyon sesi',
        buyin: 'Alın.',
        buytip: 'Pazardaki en iyi fiyatı satın alın.',
        sellprice: 'Selling price',
        sellnum: 'Ses satıyor',
        sellout: 'Satış',
        selltip: 'Pazardaki en iyi fiyata satın',
        curdelegation: 'Şimdiki komisyon',
        hisdelegation: 'Giriş Tarihi',
        num: 'miktarda',
        price: 'fiyat',
        direction: 'yön',
        time: 'Zaman',
        total: 'Etkileyici',
        action: 'operasyon',
        undo: 'Bir emri öldürün',
        done: 'Tamamlandı transaksyon',
        status: 'Durum',
        finished: 'Tamamlandı',
        canceled: 'iptal edildi',
        buyamounttip: 'Lütfen satın miktarını girin',
        buyamounttipwarning: 'Satış miktarı aşamaz',
        success: 'Başarılı gönderildi',
        pricetip: 'Please enter the transaction amount',
        pricetipwarning: 'The transaction amount cannot exceed',
        sellamounttip: 'Lütfen satış miktarını girin',
        sellpricetip: 'Lütfen satış fiyatını girin',
        undotip: 'Emri iptal etmek için emin misin?',
        cancelsuccess: "Vazgeçme başarılı!",
        marketprice: 'pazar fiyatı',
        depth: "Derin haritası",
        dateTimeDay: "Gün",
        moredetail: "daha fazla detaylar"
        // recharge: '充币',
        // fees_rate: '费率',
        // balance: '资产',
        // or: '或',
        // starttrade: '开始交易',
        // disablesellout: "禁止市价卖出",
        // disablebuyin: "禁止市价买入",
        // realtransaction: '实时成交',
        // stall: '档位',
        // high: '高',
        // low: '低',
        // vol: '24H量',
        // buy: '买入',
        // sell: '卖出',
        // traded: '已成交',
        // delegationnum: '委托量',
        // parted: "部分成交",
        // tip: '提示',
        // sellamounttipwarning: '卖出数量不能高于',
        // sellpricetipwarning: '卖出价格不能高于',
        // market: '市场',
        // favorite: '收藏',
        // dateTimeHour: "时",
        // dateTimeMinutes: "分",
        // dateTimeSeconds: "秒",
        // expand: {
        //     time: '时间',
        //     price: '价格',
        //     amount: '数量',
        //     fee: '手续费',
        // },
        // realtime: '分时',
        // kline: "K线图",

    },
    swap: {
        Sw1: "Kreskiñ ar marz",
        Sw2: "Izelaat ar marz",
        Sw3: "Kreskiñ",
        Sw4: 'Reduiñ',
        Sw5: "Margin",
        Sw6: 'aotreet uchek',
        Sw7: 'zo Ar gwerzh lakaet goude',
        Sw8: 'eo Ar gwerzh leverezh goude',
        Sw10: "Kreskiñ marz an traoù",
        Sw11: "Digreskiñ riblenn an traoù",
        Sw12: ' Skrid deskrivadur ',
        Spsl1: "Gerçekten tetikleyici zamanı",
        Spsl2: "Aslında tetikler sayısı",
        Spsl3: 'Aslında tetikleyici yöntem.',
        Spsl4: "Gerçek tetikçi fiyatı",
        contract: "sözleşme",
        swapindex: "sürdürülebilir",
        lastprice: 'Son fiyat',
        daychange: '24 saat yükselip düştün.',
        vol: '24H miktarı',
        limited_price: 'sınır düzeni',
        market_price: 'pazar düzeni',
        spot_price: 'Parayı durdur ve kaybetmeyi durdur.',
        or: 'Mor',
        curdelegation: 'Şimdiki komisyon',
        hisdelegation: 'Tarihi komisyonu',
        num: 'miktarda',
        time: 'Zaman',
        undo: 'Bir emri öldürün',
        success: 'Başarılı gönderildi',
        cancelsuccess: "Vazgeçme başarılı!",
        marketprice: 'pazar fiyatı',
        open: "Rahatlatmak için büyükanneyi a ç.",
        close: "Konum kapatılıyor",
        myswapaccount: "Anlaşma hesabım",
        accountmode: "Hesap Modu",
        accountmargin: "Çift kontrat",
        accountquanyi: "Hesapın toplam eşit",
        profitandloss: "Anlamayan kazançlar ve kaybılar",
        principalAmount: "Boş sınıf",
        positionAmount: "Position margin",
        frozenAmount: "Freeze margin",
        principalRate: "Fund utilization rate",
        zijinhuazhuan: "Fond aktarımı",
        up: "çok",
        down: " boş",
        canup: "Kaiduo",
        candown: "Boş açılabilir",
        cancloseup: "Kısa pozisyonlar dengelenabilir",
        canclosedown: "Çoklu depolar dengelenir",
        openup: "Kaiduo'yu satın al.",
        opendown: "Kısa pozisyonları satıyor",
        closeup: "Evi satın al",
        closedown: "Pingduo satıyor",
        currentposition: "Mevcut pozisyon",
        marginMode1: "depodan",
        marginMode2: "Tam depo",
        modifyMarginModeTitle: "Esap modunu değiştir",
        modifyLeverage: "Adjusting contract multiples",
        shareNumber: "Zhang",
        entrustprice: "Komisyon fiyatı",
        triggleprice: "Ödeme fiyatı",
        openvolume: "Çokluğu açılıyor",
        closevolume: "Kıymetleri kapatıyor",
        triggleplaceholder: "Öntanımlı komisyon fiyatı pazar fiyatıdır.",
        marketpriceplaceholder: "En iyi pazar fiyatına satış",
        levmaxtip: "Anlaşma çoğu maksimum çoğundan yüksek olamaz.",
        levmintip: "Anlaşma çoğu en az çoğundan daha düşük olamaz.",
        marginModeSuccessTip: "Kont hesap modusu başarıyla değiştirildi",
        noenoughbalance: "Yetersiz hesap margini",
        pleaseinputopenvolume: "Açıklama miktarı 0'dan daha büyük olmalı.",
        pleaseinputcorrectopenvolume: "Lütfen doğru açılış miktarını girin",
        pleaseinputrightentrustprice: "Lütfen doğru komisyon fiyatını girin",
        noenoughposition: "Yeterince mevcut pozisyonlar",
        pleaseinputclosevolume: "Yapılan miktarı 0'dan daha büyük olmalı.",
        pleaseinputcorrectclosevolume: "Lütfen doğru kapatma miktarını girin",
        pos_Pl: "gelir",
        pos_Ratio: "Yield",
        pos_pos: "open interest",
        pos_openPrice: "Orta açılış fiyatı",
        pos_mRatio: "Margin ratio",
        ent_entrustType: "Yerleri açmak/kapatmak",
        ent_direction: "yön",
        ent_type: "Giriş türü",
        ent_trigglePrice: "Ödeme fiyatı",
        ent_entrustPrice: "Komisyon fiyatı",
        ent_tradedPrice: "Transaksyon fiyatı",
        ent_margin: "Margin",
        ent_volume: "Komisyon Sayısı",
        ent_status1: "Komisyonda",
        ent_status2: "yeniden kaydedildi",
        ent_status3: "Silme başarısız oldu",
        ent_status4: "Başarılı verildi",
        ent_pl: "Düzenleme zararı ve kaybı",
        ent_fee: "Ödemeleri yönetme",
        triggerpriceshouldbigger: "Daha fazla fiyat 0'dan daha büyük olmalı."
        // ent_statusblast: "爆仓",
        // ent_status: "委托状态",
        // pos_cmRatio: "维持保证金率",
        // pos_long: "多头",
        // pos_short: "空头",
        // pos_leverage: "合约倍数",
        // pos_margin: "当前保证金",
        // pos_canClose: "可平量",
        // moredetail: "更多详情",
        // assetsdetail: "资金明细",
        // latestdeal: "最新交易",
        // expand: {
        //     time: '时间',
        //     price: '价格',
        //     amount: '数量',
        //     fee: '手续费',
        // },
        // realtime: '分时',
        // kline: "K线图",
        // depth: "深度图",
        // pricetip: '请输入交易额',
        // pricetipwarning: '交易额不能高于',
        // sellamounttip: '请输入卖出量',
        // sellamounttipwarning: '卖出数量不能高于',
        // sellpricetip: '请输入卖出价格',
        // sellpricetipwarning: '卖出价格不能高于',
        // undotip: '是否确认撤单？',
        // delegationnum: '委托量',
        // done: '已成交',
        // status: '状态',
        // finished: '已完成',
        // canceled: '已取消',
        // parted: "部分成交",
        // tip: '提示',
        // buyamounttip: '请输入买入量',
        // buyamounttipwarning: '买入数量不能高于',
        // stall: '档位',
        // total: '累计',
        // traded: '已成交',
        // action: '操作',
        // coin: '币种',
        // symbol: "交易对",
        // volume: "成交量",
        // market: '市场',
        // favorite: '收藏',
        // do_favorite: '已收藏',
        // cancel_favorite: '取消收藏',
        // type: "类型",
        // dealamount: "成交金额",
        // high: '高',
        // low: '低',
        // buy: '买入',
        // sell: '卖出',
        // fees_rate: '费率',
        // balance: '资产',
        // starttrade: '开始交易',
        // canuse: '可用',
        // recharge: '充币',
        // buyprice: '买入价',
        // buynum: '买入量',
        // amount: '交易额',
        // buyin: '买入',
        // disablebuyin: "禁止市价买入",
        // buytip: '以市场上最优价格买入',
        // sellprice: '卖出价',
        // sellnum: '卖出量',
        // sellout: '卖出',
        // disablesellout: "禁止市价卖出",
        // selltip: '以市场上最优价格卖出',
        // price: '价格',
        // direction: '方向',
        // realtransaction: '实时成交',
    },
    subscribe: {
        Su1: 'Details page',
        Su2: 'İmzalama',
        Su3: 'Yeni para aboneliği',
        Su4: 'Başlamak için',
        Su5: "ilerliyor",
        Su6: "Anlatılacak",
        Su7: 'Uzak',
        Su8: 'Başlat',
        Su9: 'Ödül fiyatı',
        Su10: 'Estimated profit and loss ratio',
        Su11: 'Başlangıç zamanı',
        Su12: "Yayım zamanı",
        Su13: "Detaylar",
        Su14: 'İmzalama',
        Su15: 'İmzalama kayıtları',
        Su16: 'Vali adı',
        Su17: 'Önemli fiyat',
        Su18: ' Önemli fiyat',
        Su19: 'Kazanan teklif sayısı',
        Su20: 'Refund amount',
        Su21: 'Zaman',
        Su22: 'Durum',
        Su23: "Zaman",
        Su24: "İmzalama miktarı",
        Su25: 'İmzalama Vali',
        Su26: 'Ödül fiyatı',
        Su27: "Tahmin edilen kazanç ve kaybı",
        Su28: "İmzalama sınırı",
        Su29: 'İmzalama başlangıç zamanı',
        Su30: 'Subscription end time',
        Su31: "Sonuçların açıklama günü",
        Su32: "Tahmin edilen başlatma zamanı",
        Su33: "İmzalama miktarı",
        Su34: 'Valüt',
        Su35: "İmzalama miktarı",
        Su36: "İmzalama zamanı",
        Su37: 'Durum',
        Su38: "Anlatılacak",
        Su39: 'Published',
        Su40: 'Project information',
        Su41: "Available balance",
        Su42: ' Derhal uygulayın',
        Su43: "Hepsi",
        Su44: 'Payment password',
    },
    option: {
        minute: 'Minute',
        enter: 'Please enter',
        buyup: "bullish",
        buydown: "bearish",
        closeprice: "Closing price",
        balancenotenough: "Yeterince available balance!",
        or1: 'Son fiyat.',
        or2: "Daha iyi zaman",
        or3: 'Bahse girin.',
        or4: "Bahse girmek",
        or5: "Diğer sayılar",
        or6: "Şimdiki fiyat gerçekleştirilmiş fiyattır.",
        or7: 'Historical',
        or8: "şanslar",
        or9: 'Bonus.',
        or10: 'Transaksyon kayıtları',
        or11: "Lütfen genellikle kullanılan USDT bahse sayılarını seçin",
        // title: "期权合约",
        // buyupreward: "买涨总额",
        // buydownreward: "买跌总额",
        // quantity: "开仓金额",
        // myamount: "我的开仓",
        // history: "往期结果",
        // seriers: "第",
        // period: "期",
        // currentoption: "本期预测周期",
        // openprice: "开盘价",
        // currentprice: "当前价",
        // openprice1: "开盘价格",
        // opentime: "开盘时间",
        // closetime: "收盘时间",
        // progress: "预测进度",
        // loginFirst: "请先登录!",
        // selectAmount: "请选择投注数量",
        // betsuccess: "恭喜你！投注成功！",
        // noopening: "暂无待期权合约",
        // col_createTime: "创建时间",
        // col_direction: "预测方向",
        // col_result: "预测结果",
        // col_optionNo: "合约期数",
        // col_betAmount: "开仓金额",
        // col_rewardAmount: "奖金数量",
        // col_fee: "开仓手续费",
        // col_winfee: "抽水",
        // win: "成功",
        // lose: "失败",
        // wait: "进行中",
        // avaliablebalance: "可用余额",
        // login: "请先登录",
        // kline: "实时行情",
    },
    activity: {
        endtime: "Son zamanı",
    },
    uc: {
        login: {
            noaccount: 'Hiçbir hesap yok mu?',
            register: 'Register',
            login: ' gir',
            pwdtip: 'Lütfen parola girin',
            forget: 'Parola unut?',
            loginvalidate: 'Lütfen hesap numarasını girin',
            success: 'İçeri başarılı',
            goregister: "Şimdi kaydedin",
            // getlostpwd: "忘记密码"
            // pwdvalidate1: '请输入密码',
            // pwdvalidate2: '密码长度不能少于6位',
            // validatecodeload: '正在加载验证码',
            // validatemsg: '请先完成验证',
            // welcomelogin: '欢迎登录',
            // usertip: '请输入邮箱',
        },
        forget: {
            title: "Parola alın",
            sendcode: 'Denetim kodu gönder',
            save: 'Teslim et',
            mtelno: 'Mobil Telefon Kimliği',
            memail: 'E-posta doğrulama',
            // hasaccount: '已有账号？请点击登录',
            // login: '登录',
            // newpwd: '请输入新密码',
            // confirmpwd: '请再次确认密码',
            // pwdvalidate1: '请输入确认密码',
            // pwdvalidate2: '两次密码输入不一致!',
            // resettelpwd: '重置手机密码',
            // resetemailpwd: '重置邮箱密码',
            // newpwdtip: '请输入新密码',
            // pwdvalidate3: '密码长度不能少于6位',
            // telno: '手机号',
            // smscode: '请输入验证码',
            // teltip: '请输入手机号',
            // smscodetip: '请输入短信验证码',
            // email: '邮箱',
            // emailcode: '邮箱验证码',
            // emailtip: '请输入邮箱',
            // emailcodetip: '请输入邮箱验证码',
            // resetpwdsuccess: '重置密码成功',
            // smswarn: '请注意查收短信',
        },
        finance: {
            fi1: 'Küçük maliyetleri sakla',
            personalassets: 'Coin hesabı',
            swapassets: 'perpetual account',
            billdetail: 'Varlık akışı',
            // center: '财务中心',
            // tradetail: '交易挖矿',
            // paydividends: '持币分红',
            // invitingmining: '邀请挖矿奖励',
            // charge: '充币',
            // pickup: '提币',
            money: {
                M1: 'Kıymet alındı',
                M2: 'Kıymetleri dışarı aktar',
                M3: 'Değiştirme hızı',
                cointype: 'Para ismi',
                balance: 'Available assets',
                frozen: 'Dondurma malları',
                operate: 'operasyon',
                charge: 'Parayı yeniden yükleyin',
                pickup: 'Parayı kaldırmak',
                onkeytrans: "Bir tık dönüşü",
                resetsuccess: 'Başarılı alındı',
                needreleased: "Serbest bırakılacak mallar",
                totalassets: "Toplam maliyetler dönüştürüldü"
                // getaddress: '获取地址',
                // match: '配对',
                // matchtip1: '可配对GCX的数量',
                // matchtip2: '请输入配对数量',
                // matcherr1: '请输入有效的数量!',
                // matcherr2: '超出最大配对数量!',
                // matchsuccess: '配对成功!',
            },
            swap: {
                currencyaccount: "Coin account",
                profitandloss: "Anlamayan kazançlar ve kaybılar",
                transfor: "Fond aktarımı",
                inputtransferamount: "Taşıma miktarı",
                swaptype: 'Kontrakt hesabı',
                avaamount: "Convertible credit limit",
                pleaseselectwallet: "Lütfen önce nakliye/dışarı için hesabı seçin",
                pleaseinputamount: "Lütfen aktarım miktarını girin",
                oktransfer: "Transferi doğrula"
                // totalassets: "账户权益折合：",
                // swap: " 永续账户",
                // swapassets: "账户权益",
                // avabalance: "可用保证金",
                // usebalance: "已用保证金",
                // frozenbalance: "冻结保证金",
                // all: "全部划转",
                // swapaccount: "永续合约账户",
                // clickchange: "点击切换划转方向",
            },
            record: {
                operatetype: 'Operasyon türü',
                charge: 'yükle',
                pickup: 'Çıkart',
                exchange: 'Vali transaksyonu',
                otcbuy: 'Nişanlı para satın alın',
                otcsell: 'Nişanlı para satıyor',
                handrecharge: 'El yükleme',
                chargetime: 'Transaction time',
                type: 'Type',
                fee: 'Ödemeleri yönetme',
                revenue: 'Geldi ve harcama türleri',
                symbol: 'para',
                num: 'miktarda',
                status: 'Durum',
                finish: 'Tamamlandı',
                quickExchange: "Flash exchange",
                contractfee: "Predicting contract failure",
                optionfail: "Predicting contract failure",
                optionreward: "Anlaşma Bonus'u tahmin et",
                other: "Diğer"
                // search: '搜索',
                // transaccount: '转账',
                // activityaward: '活动奖励',
                // promotionaward: '推广奖励',
                // dividend: '分红',
                // vote: '投票',
                // match: '配对',
                // activitybuy: "活动兑换",
                // ctcbuy: "CTC买入",
                // ctcsell: "CTC卖出",
                // redout: "发红包",
                // redin: "领红包",
                // shouldfee: '应付手续费',
                // re1: '入账',
                // re2: '出账',
                // discountfee: '抵扣手续费',
                // realfee: '实付手续费',
                // activitybuy: "活动兑换",
                // ctcbuy: "C2C买入",
                // ctcsell: "C2C卖出",
                // currentRate: "当前兑换比率",
                // from: "从",
                // inputexchangeamount: "输入闪兑数量",
                // inputexchangepasswd: "输入交易密码",
                // chooseTransCoinUnit: "选择转化币种",
                // inputTransAmount: "输入转化数量",
                // predictAmount: "预计可兑数量",
                // qamount: "闪兑数量",
                // qrate: "兑换比例",
                // qexamount: "兑换数量",
                // withdrawcodein: "提币码充币",
                // withdrawcodeout: "提币码提币",
                // contractprofit: "永续合约盈利",
                // contractloss: "永续合约亏损",
                // optionfee: "预测合约手续费",
                // Please: '请选择搜素日期范围',
                // start_end: '起止时间',
                // to: '至',
            },

            trade: {
                start_end: 'Başlama ve bitme zamanı',
                search: 'arama',
                type: 'tür',
                symbol: 'Transaksyon çiftleri',
                direction: 'Trading direction',
                buy: "Alın.",
                sell: "Satış",
                limit: "Ceza sınırı",
                market: "pazar fiyatı",
                clear: "Şartları temizle",
                // account_date: '到帐时间',
                // to: '至',
                // operatetype: '操作类型',
                // charge: '充值',
                // pickup: '提现',
                // transaccount: '转账',
                // exchange: '币币交易',
                // otcbuy: '法币买入',
                // otcsell: '法币卖出',
                // activityaward: '活动奖励',
                // promotionaward: '推广奖励',
                // dividend: '分红',
                // vote: '投票',
                // handrecharge: '人工充值',
                // match: '配对',
                // chargetime: '订单生成时间',
                // fee: '挖矿手续费返还(BHB)',
                // num: '数量',
                // status: '状态',
                // finish: '已完成',
                // transactionTime: '交易时间',
                // price: '价格',
                // entrustment: '委托量',
                // havedeal: '已成交',
                // poundageAmount: '手续费',
                // exchangeOrderId: "订单ID",
                // mineAmount: "挖币数量 (BHB)",
                // turnover: "成交金额"
            },

            recharge: {
                symbol: 'para',
                address: 'Adresi yeniden yükle',
                qrcode: 'QR kodu',
                msgtop: 'Bu adres sadece mallarını yeniden yükleyebilir',
                msg1: 'Please do not recharge any non monetary assets to the above address, otherwise the assets will not be recoverable.',
                msg2: 'Yukarıdaki adrese yeniden yüklendikten sonra tüm blok zinciri ağ düğümünden onaylamalısınız. Genelde blok zinciri ana ağı üç ağ onaylamalarından sonra ödeme alır.',
                msg3: 'Minimal yeniden yükleme miktarı:',
                msg3_1: "Minimal miktarın altındaki yeniden yüklemeler kredi edilmeyecek.",
                msg4: 'Your recharge address will not change frequently and can be recharged repeatedly; Eğer değişiklikler varsa, sizi web açıklamaları veya e-postaları üzerinden haber vermek için en iyisini deneyeceğiz.',
                msg5: 'Please make sure to ensure the security of your computer and browser to prevent information from being tampered with or leaked.',
                record: 'Kayıtları yeniden yükleyin',
                copysuccess: 'Başarılı anladım!',
                time: 'Alış zamanı',
                amount: 'Yeniden yükleme miktarı',
                gettingaddress: "Getting recharge address, please wait...",
                getaddress: "Yeniden yükleme adresini alın",
                // memotips: "充值时请按要求输入此Memo，否则会丢失资产。",
                // withdrawrecharge: "提币码充值",
                // coderechargetip: "请输入提币码",
                // rechargesuccess: "恭喜！提币码充值成功！",
                // rechargeconfirm: "充值确认",
                // status: "状态"
                // copyerr: '复制失败！请手动复制',
                // qrcodeaddress: '充值地址二维码',
                // copy: '复制',
                // recharge: '充币',
            },
            withdraw: {
                pickup: 'Parayı kaldırmak',
                symbol: 'para',
                address: 'Çıkart adresi',
                num: 'Kaldırma miktarı',
                fee: 'Ödemeleri yönetme',
                arriamount: 'Alılan miktarda',
                record: 'Kayıtları çek',
                symboltip: 'Lütfen para seçin',
                time: 'Kaçırma vakti',
                status: 'Durum',
                status_1: 'Gözlemde',
                status_2: 'Transfer içinde',
                status_3: 'başarısız',
                status_4: 'başarılı',
                St5: 'Tahmin edilen Güçlü Paritesi',
                St6: 'Total assets=wallet balance+unrealized',
                St7: 'Anlamayan kazanç ve kaybı=Anlamayan kazanç ve kaybı tüm sözleşmeler için son fiyatı kullanarak hesaplanmış.',
                St8: 'Cüzdanın dengesi=dışarı+kazançları ve kaybetmeleri fark etti',
                St9: 'Red edildi',
                add: 'Ekle',
                delete: 'delete',
                txid: "TxId",
                wi1: 'Network',
                wi2: 'Güvenlik yetki',
                wi3: 'Çoklu alındı',
                wi4: 'Delivery address',
                wi5: 'Withdrawal Network',
                wi6: 'Toplam çekilme miktarı.',
                wi7: 'Ağ ücretleri',
                wi8: 'Please ensure that you have entered the correct withdrawal address and that the withdrawal network you have selected matches the address',
                wi9: "Geri çekilme emri yarattıktan sonra iptal edilemez.",
                wi10: 'Devam et',
                wi11: 'Fonda parola',
                wi12: 'Mobil doğrulama kodu',
                wi13: 'Doğru yolla',
                wi14: 'E-posta doğrulama kodu',
                wi15: 'Send verification',
                wi16: 'Submit',
                // addressmanager: '提币地址管理',
                // withdrawbycode: '提币码提币',
                // withdrawcode: '提币码',
                // avabalance: '可用余额',
                // msg1: '提币数量低于',
                // msg2: '时自动到账，否则需要人工审核',
                // increase: '提升额度',
                // tip1: '最多输入',
                // tip11: '位小数,最小值为',
                // tip2: '最大值为',
                // numtip1: '输入提币数量',
                // range: '范围',
                // msg3: '最小提币数量为',
                // msg4: '币',
                // msg5: '为保障资金安全，当您账户安全策略变更、密码修改、使用新地址提币，我们会对提币进行人工审核，请耐心等待工作人员电话或邮件联系',
                // msg6: '请务必确认电脑及浏览器安全，防止信息被篡改或泄露。',
                // addresstip: '请填入地址',
                // numtip2: '请填写正确提币数量，最小值为',
                // numtip3: '提币数量不得小于手续费',
                // amounttip: '请输入提币数量',
                // feetip1: '手续费最小值为',
                // feetip2: '最大值为',
                // remark: '备注',
                // addresslist: '地址列表',
                // safevalidate: '安全验证',
                // telno: '手机号码',
                // smscode: '手机验证码',
                // second: '秒',
                // clickget: '点击获取',
                // email: '邮箱',
                // emailcode: '邮箱验证码',
                // save: '保 存',
                // telerr: '手机号不正确',
                // emailerr: '邮箱不正确',
                // codeerr: '验证码不正确',
                // remarktip: '请输入备注',
                // savemsg1: '保存失败!',
                // savemsg2: '保存成功!',
                // operate: '操作',
                // fundpwdtip: '请输入资金密码',
                // click: '点击',
                // filtrate: '可筛选',
                // generateCode: "生成提币码",
                // withdrawcodelist: "提币码列表",
                // withdrawcodestatus: "状态",
                // submit: "提交",
                // generatecodesuccess: "提现码生成成功",
            }
        },
        member: {
            usercenter: "Kişisel Merkez",
            account: "Hesap Yönetimi",
            assets: "fond yönetimi",
            exchange: "Transaction Management",
            curdelegate: "Current commission",
            hisdelegate: "Tarihi komisyonu",
            // securitycenter: '安全中心',
            // securitysetting: '安全设置',
            // accountsetting: '收款方式',
            // otc: "OTC管理"
        },
        regist: {
            Res1: 'Kullanıcı adı boş olamaz, büyük ve küçük harfler ve sayılardan oluşan ve harfler içerilmeli.',
            username: 'kullanıcı adı',
            smscode: 'Kontrol kodu',
            sendcode: 'Denetim kodu gönder',
            pwd: 'Giriş paroli',
            repwd: 'Parola doğrula',
            agreement: 'Okudum ve kabul ettim',
            userprotocol: 'Kullanıcı Anlaşması',
            regist: 'kayıt',
            teltip: 'Lütfen telefon numarasını girin.',
            telerr: 'Telefon numarası format ı yanlış. Lütfen yeniden girin',
            emailtip: 'Lütfen e-posta adresinizi girin',
            emailerr: 'E-posta format ı yanlış, lütfen yeniden girin',
            confirmpwdtip: 'Lütfen doğrulama parolanı girin',
            confirmpwderr: 'İki parola giriş uygunsuz!',
            pwdtip: 'Lütfen giriş parolanızı girin',
            pwdmsg: 'Parola uzunluğu 6 rakamdan az olamaz',
            telno: 'Cep telefonu numarası',
            email: 'E-posta adresi',
            agreementtip: 'Please click agree',
            promotion: 'Davet kodu',
            emailregist: 'E-posta kayıtları',
            usernametip: 'Bir kullanıcı adını gir',
            // telregist: '手机注册',
            // hasaccount: '已有账号？请点击登录',
            // login: '登录',
            // country: '国家',
            // resendcode: '重新发送(',
            // confrimpwd: '确认密码',
            // usernamemsg: '用户名长度不能少于3位,多于15位',
            // countrytip: '请选择国家',
            // smscodetip: '请输入短信验证码',
            // modaltitle: '请校验',
            // china: '中国',
            // singapore: '新加坡',
            // korea: '韩国',
            // japan: '日本',
            // thailand: '泰国',
            // russia: '俄罗斯',
            // uk: '英国',
            // vietnam: '越南',
            // india: '印度',
            // italy: '意大利',
            // hk: '香港',
            // malaysia: '马来西亚',
            // taiwan: '台湾省',
            // turkey: '土耳其',
            // germany: '德国',
            // france: '法国',
            // spain: '西班牙',
            // us: '美国',
        },
        safe: {
            Ad1: 'Lütfen sosyal güvenlik kartınızı, s ürücü lisansını ya da pasaportunuzu yükleyin',
            Ad2: 'Teslim etmeden önce dosyalardan birini yükle',
            Ad3: 'Tam isim',
            Ad4: 'Kontakt adresi',
            Ad5: 'Canlı akışlar',
            Ad6: "Hayatım",
            Ad7: 'Ekleme başarısız, en fazla 3 eklenebilir',
            safelevel_low: 'Security level: low',
            safelevel_high: 'Güvenlik seviyesi: Yüksek',
            safelevel_medium: 'Security level: medium',
            bind: 'bağ',
            binded: 'Sıçrama',
            binding: 'Gözlemde',
            bindretry: 'geri dene',
            verifypass: "Kullanılmış",
            verified: 'Gerçek isim doğrulaması',
            notverified: "Kimlikdoğrulamadı",
            verifiedtip: 'Hesapınızın güvenliğini sağlamak için, lütfen transaksyonu işlemeden önce gerçek isim onayını tamamlayın!',
            save: 'baocun',
            reset: 'Sıfırla',
            email: 'postakutusu',
            bindemail: 'Bindemail',
            loginpwd: 'Giriş paroli',
            emailcode: 'E-posta doğrulama kodu',
            clickget: 'Click to obtain',
            second: 'second',
            phone: 'cep telefonu',
            bindphone: 'Bağlı telefon',
            phonecode: 'Mobil doğrulama kodu',
            logintip: 'Platforma girdiğinde kullan',
            edit: 'değiştir',
            oldpwd: 'Orijinal giriş paroli',
            newpwd: 'Yeni giriş paroli',
            confirmnewpwd: 'Yeni parolanı doğrula',
            fundpwd: 'Fonda parolanı',
            fundtip: 'Hesap fonlarının değişikliği olduğunda, fonda parolanı ilk doğrulamak gerekir',
            set: 'ayarlandır',
            confirmpwd: 'Parola doğrula',
            oldfundpwd: 'Orijinal fon şifresi',
            newfundpwd: 'Yeni fon şifresi',
            newpwdmsg1: 'Lütfen 6 karakterden az olmayan yeni giriş parolanı girin',
            newpwdmsg2: 'Yeni giriş paroli uyumlu değil',
            pwdmsg1: 'Lütfen 6 rakamdan az bir parola girin',
            pwdmsg2: 'Parola uyumsuz',
            emailtip: 'Lütfen e-posta numarasını girin',
            codetip: 'Please enter the verification code',
            realnametip: 'Lütfen gerçek isminizi girin',
            idcardtip: 'Lütfen kimlik numarasını girin',
            upload_negativetip: 'Lütfen kimlik kartınızın arkasındaki fotoğrafını yükleyin',
            upload_handtip: 'Lütfen el kullanıcı kimliğinizi ve fotoğrafınızı yükleyin',
            save_success: 'Başarılı kurtar!',
            save_failure: 'Kaydet başarısız oldu!',
            idcard_verifymsg1: "1、8MB'den daha küçük dosyalarla JPG ve PNG formatlarını destekler; Belgedeki bilgi, değişiklik veya engellenmeden temiz ve görünür olmalı ve belge numarası ve isim açıkça görünmelidir.",
            idcard_verifymsg2: "2、Fotoğraf şapka olmadan çekilmeli ve makyaj giymeye tavsiye ediliyor. Kimlik belgesi tutan kişinin yüz özellikleri a çık ve tanınabilir ve kolu tamamen açık olmalı.",
            idcard_verifymsg3: "3、I need to hold both my ID and handwritten copy (name+application date) at the same time. All my actions on this site are my own and I am aware of the relevant risks. I am willing to bear all legal consequences of this account."
            // telnotip: '请输入手机号',
            // oldpwdtip: '请输入原密码',
            // bindphonetip: '请先绑定手机!',
            // resetfundpwd: '重置资金密码',
            // upload_positivetip: '请上传身份证正面照',
            // binderr: '失败',
            // realname: '真实姓名',
            // nickname: '昵称',
            // size: '上传图片大小不能超过5M',
            // idcard: '身份证号',
            // upload: '点击上传',
            // upload_positive: '身份证正面照',
            // upload_negative: '身份证反面照',
            // upload_hand: '手持身份证与个人签名照',
        },
        otcorder: {
            money: 'Para',
        },
        extension: {
            currrecharge: 'Mevcut',
        },
        promotion: {
            exchange: "Yeniden hazırla",

        },
        // mining: {
        //     title: "我的矿机列表",
        //     empty: "暂无矿机",
        //     day: "天",
        //     week: "周",
        //     month: "月",
        //     year: "年",
        //     invitetip1: "本矿机产能可通过邀请好友获得提升，每邀请一人兑换矿机，产能提升",
        //     invitetip2: "%，产能提升上限",
        //     miningUnit: "产出币种",
        //     miningPeriod: "产出周期",
        //     miningDays: "挖矿时间",
        //     miningedDays: "已挖时间",
        //     miningDaysProfit: "基础产能",
        //     miningCurrentDaysProfit: "实际产能",
        //     status0: "待部署",
        //     status1: "已部署",
        //     status2: "已结束"
        // },
        // locked: {
        //     title: "我的锁仓列表",
        //     empty: "暂无锁仓",
        //     day: "天",
        //     week: "周",
        //     month: "月",
        //     year: "年",
        //     invitetip1: "本锁仓产能可通过邀请好友获得提升，每邀请一人参与锁仓，产能提升",
        //     invitetip2: "%，产能提升上限",
        //     miningUnit: "释放币种",
        //     miningPeriod: "释放周期",
        //     miningDays: "总释放周期",
        //     miningedDays: "已释放周期",
        //     miningDaysProfit: "基础释放",
        //     miningCurrentDaysProfit: "实际释放",
        //     status0: "待释放",
        //     status1: "释放中",
        //     status2: "已结束",
        //     totallocked: "总锁仓"
        // },
    },
    cms: {
        noticecenter: 'Bildirim Merkezi',
        notice: 'duyuru',
        servicecenter: 'Customer Service Center',
        aboutus: 'Bizim hakkımızda',
        features: "Platform özellikleri",
        contactus: "Bizimle iletişim kur",
        nextnotice: 'Sonraki makale',
        prevnotice: "Önceki makale",
        notexist: "Ziyaret ettiğiniz duyuru yok ya da silildi!",
        otherhelp: "Articles within this group",
        scanforshare: "Tara ve paylaş",
        download: "Download Now",
        downloadslogan: "- Global Digital Asset Trading Platform"
        // newshelp: '新手帮助',
        // appdownload: 'APP下载',
        // onlineservice: '在线客服',
        // faq: '常见问题',
        // exchangerule: '交易规则',
        // about: '关于',
        // joinus: '加入我们',
        // useprotocol: '使用协议',
        // feenote: '资费说明',
        // merchantprocotol: '商家协议',
        // noticelist: '公告列表',
    },
    description: {
        title1: 'Mali seviye güvenliği',
        title2: 'Ekstra Yükleme ve Yükleme',
        title3: 'Küresel Hizmetler',
        title4: 'İşleri kesinlikle seçin',
        message1: 'Tümleşik finansal riski kontrol sistemi ve hırsızlık karşı sistemi, sıcak ve soğuk cüzdanlar ve çoklu imzalama sistemi fond güvenliğini sağlar',
        message2: '3 dakikaya kadar yeniden yükleme ve çekme tamamlanabilir, müşterilerin en iyi yatırım fırsatlarını kaybetmekten korumak için 24 saatlik internet kontrolü ile',
        message3: 'Küresel iş servisi ağ kapatımı küresel şifreli maliyetlere yatırım yaptırır ve küresel kullanıcılarla bağlantı yaptırır.',
        message4: 'Yüksek kaliteli şifreleme projelerini seçin ve sizin için aşırı yüksek riskli projelerin %80 ünü sil',
        // scanqrcode: "扫描二维码，下载APP",
        aboutdesc1: "Kıyman Adalarında kayıtlı, Hong Kong'da bulunan temel operasyon takımıyla dünyaya yönetici bir dijital aktarım ticaret platformu. Merkezi üyeler en yüksek İnternet ve mali şirketlerden gelir. Onların çoğu derin bitcoin ve blok zinciri inananlar",
        aboutdesc2: "Platformun profesyonel bir finansal seviye ticaret mimarı ve kendi gelişmiş yüksek bir anlaşma hafızası ticaret motoru ile uyuşuyor. Platforma, müşterilerin güvenliğini sağlamak için soğuk bir cüzdanı sistemi, çoklu imzalar ve yüksek koruma DDOS saldırı sistemini kabul ediyor.",
        aboutdesc3: "Müşterilerin yatırım fırsatlarını daha iyi yakalaması için müşteriler hizmeti bölümü düz yönetim yaklaşımı kabul edip hızlı bir servis cevap mekanizmasını kurdu. Müşterilerin 25 dakika içinde aktarım tekrar yüklemesi ve çekme hizmetlerini sağlamak için 24/7 internette bulunan mali müşterilerin tüm yıl içinde 24/7 üzerinde bulunuyor.",
        aboutdesc4: "Çok yüksek kaliteli projeleri görüntüle ve güvenli ve stabil mali gözaltı hizmetlerini sağla.  Dürüstlüğü, adil olmalığı, heyecanlığı ve a çılığı konseptine uyuşuyoruz, kullanıcılarımız için güvenli, güvenilir, etkili ve arkadaşlık bir değişim yaratmaya çalışıyoruz.",
        aboutdesc5: "Dijital mallar şimdi sadece küçük bir çevrede olsa da, herkesin tamamen kontrol edebileceği bu tür mallar gelecekte kesinlikle popüler olacağına inanıyoruz. Birlikte çalışalım ve bunu bekleyelim!",
        support: "teknik destek",
        report: "Sıkıntılı öneriler",
        service: "customer service",
        apply: "Coin uygulaması",
        coop: "İş işbirliği",
        community: "toplum",
        wechat: "WeChat",
        addwechat: "bmate601 bir WeChat arkadaşı olarak ekle ve WeChat güvenilir toplumuna girin",
        weibo: "micro- blog",
        twitter: "Twitter",
        biyong: "Coin use",
        telegram: "telegraf",
        medium: "Medium",
        reddit: "Reddit"
    },
    footer: {
        notice: 'Platform Announcement',
        gsmc: 'Küresel yüksek kaliteli dijital mali değiştirmesi',
        gsjj: 'hakkında',
        gywm: 'Bizim hakkımızda.',
        jrwm: 'Bize katılın',
        lxwm: 'Bizimle iletişim kur',
        bzzx: 'Yardım Merkezi',
        fwtk: 'Kullanıcı Anlaşması',
        fltk: 'Tariff Açıklaması',
        xszn: "Başlangıç Kılavuzu",
        cjwt: "Genelde sorular soruyor",
        mztk: "Kaçırma klauzulu",
        ystk: "Gizlilik Klausu",
        tkxy: "Term Anlaşması",
        gybzb: "BZB hakkında",
        kfyx: "Müşteri hizmet e-postası",
        swhz: "İş işbirliği",
        sbsq: "Coin uygulaması",
        jyzn: "Transaksyon Kılavuzu",
        bzzl: "Para bilgisi",
        tsjb: "Müzakereler Raporu",
        apidoc: "APIarayüz",
        zwkf: "Henüz açık değil"
        // wechatkefu: "微信客服",
        // wechat: "微信客服",
        // yqlj: '友情链接',
        // bah: '沪ICP备13026899号-3',
        // changjian: '常见问题',
        // shiyong: '使用协议',
        // feilv: '费率说明',
        // lianxi: '联系邮箱',
        // biyong: '币用',
        // xsrm: '新手教程',
        // czzn: '充值指南',
        // ptsm: '平台说明',
        // fysm: '交易规则',
    },
    index: {
        max: 'en yüksek',
        download_code: 'Uygulamayı indirmek için QR CODE tarayın ve hoş geldiğiniz hediyeyi iddia etmek için'
    },
    home: {
        login: {
            title: 'Para aktarımlarını aç',
            desc: '500+coin ve çeşitli ticaret araçlarını destekler',
            btnText: 'Alıştırmak için'
        },
        unlogin: {
            title: 'Dijital Vali Yolunu Başlat',
            desc: 'Yeni çalışanların faydalı paketinden zevk almak için kayıt edin',
            placinfo: 'Cep telefonu/e-posta',
            btnText: 'kayıt'
        },
        WelfareCenter: 'Welfare Center',
        Welcome_ceremony: 'Gösterimi Hoş geldiniz',
        Airdrop: 'Hava düşürmeli olmalı',
        DailyGain: 'Günlük kazançlar',
        AirdropGift: 'Hava Kupası hediyesi',
        financial_management: 'Optimal mali yönetimi',
        Zhoude: 'Zhou Zhoude',
        height_is: 'yukarı',
        Happiness: 'Beş Kutsal Karnevali',
        Monthly: 'Aylık gelir',
        CarveUp: 'Bölün ve bölün',
        download: {
            transactions_anytime: 'Her zaman, her yerde transaksyonları aç.',
            scan_code: 'İndirmek için kodu tarayın',
            download_more: 'Daha fazla indir'
        },
        brand: {
            digital_platform: 'Dijital mal ticaret platformu',
            rich_digital: 'Çeşitli ticaret ihtiyaçlarını yerine getirmek için zengin dijital mal ticareti ve mali yönetim hizmetleri',
            High_quality_digital: 'Yüksek kaliteli dijital maliyetler',
            Turnover: 'Dönüş',
            safety_risk: 'Dünyanın en yüksek güvenlik ve risk kontrol sistemi',
            multi_factor: 'Çevrimi depolama yöntemi, çoklu faktör şifreleme yöntemi, 24 saat platformu 24/7 izleme yöntemi, kullanıcı mali güvenliğinin bütün koruması',
            Security_reserve: 'Güvenlik Rezervi',
            accident: '9 yıl kaza olmadan',
            safetyrisk: 'En yüksek güvenlik riski kontrolü',
            choice_trusted: 'Milyonlarca kullanıcı için güvenilir seçim',
            transaction_service: 'Dünyadaki çoklu ülkeler ve bölgelerde yerel işlem servisi merkezlerini kurulmak için birçok iş formlarını integre eden blok zinciri ekosistemi oluşturulmak için',
            ten_thousand: 'on bin',
            User_preference: 'Kullanıcı tercihleri',
            Countries_covered: 'Ülkeleri örtüyor'
        },
        trading: {
            digital_currency: 'Dijital Vali Yolunu Başlat',
            register: 'kayıt',
            login: 'İçeri gir',
            currency_transaction: 'Para aktarımlarını aç',
            to_trade: 'Alıştırmak içins'
        }
    }

}



// WEBPACK FOOTER //
// ./src/assets/lang/tr/index.js